import { styled } from '../../../config'
import { Tag as BaseTag } from '../../Tag'

export const Tag = styled(BaseTag, {
  padding: '4px 8px',
  cursor: 'pointer',
  lineHeight: '20px',
  variants: {
    color: {
      default: {
        color: '$gray0400',
        borderStyle: 'solid',
        borderWidth: '1px',
        background: '$whiteA050',
        borderColor: '$whiteA300',
        '&:hover': { borderColor: '$whiteA050' },
        '&:active': { borderColor: '$whiteA300' }
      },
      ai: {
        color: '$gray0400',
        background: '$whiteA100',
        '&:hover': { borderColor: '$whiteA100' },
        '&:active': { borderColor: '$whiteA300' }
      },
      rounded: {
        padding: '8px 16px',
        color: '$white',
        background: '$whiteA050',
        border: 'none',
        borderRadius: '999px',
        '&:hover': { background: '$whiteA100' },
        '&:active': { background: '$whiteA050' }
      }
    },
    selected: {
      true: {}
    },
    disabled: {
      true: { cursor: 'not-allowed' }
    }
  },
  compoundVariants: [
    {
      color: 'default',
      selected: true,
      css: {
        backgroundColor: '$white',
        color: '$black'
      }
    },
    {
      color: 'default',
      disabled: true,
      css: {
        background: '$whiteA050',
        borderColor: '$whiteA300',
        '&:hover': { borderColor: '$whiteA300' }
      }
    },
    {
      color: 'ai',
      selected: true,
      css: {
        backgroundColor: '$white',
        color: '$black'
      }
    },
    {
      color: 'ai',
      disabled: true,
      css: {
        background: '$whiteA050',
        borderColor: '$whiteA300',
        '&:hover': { borderColor: '$whiteA300' }
      }
    },
    {
      color: 'rounded',
      selected: true,
      css: {
        backgroundColor: '$white',
        color: '$black',
        '&:hover': { background: '$whiteA900' },
        '&:active': { background: '$whiteA800' }
      }
    }
  ],
  defaultVariants: {
    color: 'default'
  }
})
